// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Clearform.css */

.payment-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    gap: 20px;
    /* background-color: #f0f0f0; */
    /* background-color: #f4f4f4; */
  }
  
  .processing {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .loading-spinner {
    font-size: 30px;
    animation: spin 1s linear infinite;
    color: #4099e1;
    border: 3px solid #fff;
    border-radius: 50%;
  }
  
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
  
  .circular-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    background-color: #4099e1;
  }
  
  .success-icon {
    font-size: 300px;
    color: #fff;
    animation: pulse 2s ease-in-out infinite;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(1.8);
    }
    100% {
      transform: scale(0.8);
    }
  }
  
  .success-message {
    font-size: 20px;
    color: #14c4eb;
    font-weight: bold;
    margin-top: 18px;
    opacity: 0;
    animation: bounceSuccess 0.8s ease-in-out forwards;
  }
  
  @keyframes bounceSuccess {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .confetti-canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Clearform.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,+BAA+B;IAC/B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,wCAAwC;EAC1C;;EAEA;IACE;MACE,qBAAqB;IACvB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kDAAkD;EACpD;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB","sourcesContent":["/* Clearform.css */\n\n.payment-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    gap: 20px;\n    /* background-color: #f0f0f0; */\n    /* background-color: #f4f4f4; */\n  }\n  \n  .processing {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .loading-spinner {\n    font-size: 30px;\n    animation: spin 1s linear infinite;\n    color: #4099e1;\n    border: 3px solid #fff;\n    border-radius: 50%;\n  }\n  \n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .circular-button {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    background-color: #4099e1;\n  }\n  \n  .success-icon {\n    font-size: 300px;\n    color: #fff;\n    animation: pulse 2s ease-in-out infinite;\n  }\n  \n  @keyframes pulse {\n    0% {\n      transform: scale(0.8);\n    }\n    50% {\n      transform: scale(1.8);\n    }\n    100% {\n      transform: scale(0.8);\n    }\n  }\n  \n  .success-message {\n    font-size: 20px;\n    color: #14c4eb;\n    font-weight: bold;\n    margin-top: 18px;\n    opacity: 0;\n    animation: bounceSuccess 0.8s ease-in-out forwards;\n  }\n  \n  @keyframes bounceSuccess {\n    0% {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .confetti-canvas {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
